// extracted by mini-css-extract-plugin
export default {"msg":"BibliothequePlotly_msg__N7FfK","graphMain":"BibliothequePlotly_graphMain__Ugudy"};